import { render, staticRenderFns } from "./IndexingPages.vue?vue&type=template&id=37cf84cc&scoped=true"
import script from "./IndexingPages.vue?vue&type=script&lang=js"
export * from "./IndexingPages.vue?vue&type=script&lang=js"
import style0 from "./IndexingPages.vue?vue&type=style&index=0&id=37cf84cc&prod&scoped=true&lang=scss"
import style1 from "./IndexingPages.vue?vue&type=style&index=1&id=37cf84cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf84cc",
  null
  
)

export default component.exports